import { gql } from "@apollo/client";

export const RETRIEVE_TIME_SLOTS = gql`
    query gqlRetrieveTimeSlots($nIDRestaurant: Int!) {
        data: gqlRetrieveTimeSlots(nIDRestaurant: $nIDRestaurant) {
            nID
            nIDRestaurant
            tStart
            tEnd
            nLimit
        }
    }
`;

export const RETRIEVE_TIME_SLOT_BY_ID = gql`
    query gqlRetrieveTimeSlotById($nID: Int!) {
        data: gqlRetrieveTimeSlotById(nID: $nID) {
            nID
            nIDRestaurant
            tStart
            tEnd
            nLimit
        }
    }
`;

export const RETRIEVE_AVAILABILITY_BOOK = gql`
    query gqlCheckAvailabilityBook($timeSlot: Int!, $date: String!) {
        code: gqlCheckAvailabilityBook(timeSlot: $timeSlot, date: $date)
    }
`;